/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  const el = document.querySelectorAll('.tab-palette .tab-btn');
  el.forEach(function (item, index) {
    const itemEl = document.querySelectorAll('.map_list__collections');
    let dataGroup = item.getAttribute('data-group');
    let group = dataGroup ? dataGroup.split(',') : []
    if (index) {
        itemEl.forEach(function (item, i) {
          if (group.includes(String(i + 1))) {
            console.log(itemEl[i]);
            itemEl[i].classList.add('hidden');
          }
        })   
    }
   
    item.onclick = function () {
         let dataGroup = item.getAttribute('data-group');
         let group = dataGroup ? dataGroup.split(',') : []
         itemEl.forEach(function (item, i) {
           if (group.includes(String(i + 1))) {
             if (itemEl[i].classList.contains('hidden')) {
               itemEl[i].classList.remove('hidden');
             }
           } else {
             itemEl[i].classList.add('hidden');
           }
         })
    } 
  })


  window.onload = function () {
     if (window.rome) {
        rome(document.querySelector('[name="contact[dob]"]'), {time: false})
     }
  }

  function contactUs() {
      const arcontactus = document.querySelector('#arcontactus');
      const messangersBlock = document.querySelector('.messangers-block');
      const static = document.querySelector('.static');
      const icons = document.querySelector('.icons');
      const iconsLine = document.querySelector('.icons-line');
      
      arcontactus.addEventListener('click', () => {
        arcontactus.classList.toggle('open');
        messangersBlock.classList.toggle('show-messageners-block');
      });
      
      const staticFunc = () => {
        // 第一秒增加hide class
        static.classList.remove('hide');
        icons.classList.add('hide');
      
        // 第二秒移除hide class
        setTimeout(() => {
          static.classList.add('hide');
          icons.classList.remove('hide');
        }, 1000);
      
        // 第三秒将icons-line的style的修改成transform: translate(-194px, 0px);
        setTimeout(() => {
          iconsLine.style.transform = 'translate(-66px, 0px)';
        }, 1500);
      
        // 第三秒将icons-line的style的修改成transform: translate(-194px, 0px);
        setTimeout(() => {
          iconsLine.style.transform = 'translate(-130px, 0px)';
        }, 1750);
      
        // 第三秒将icons-line的style的修改成transform: translate(-194px, 0px);
        setTimeout(() => {
          iconsLine.style.transform = 'translate(-194px, 0px)';
        }, 2000);
      };
      
      setInterval(() => {
        staticFunc();
      }, 3000); 
  }

  contactUs()

  function updateCarouselProduct () {
    if (!document.querySelectorAll('.product-main').length) {
      return
    }

    const elems = document.querySelector('.flickity-button-box');
    if (elems) {
      var newElement = document.createElement("div");
      newElement.innerHTML = elems.innerHTML;
      elems.remove();
      document.querySelector('.product-main .flickity-viewport').appendChild(newElement);
      const prevEl = document.querySelector('.product-main .flickity-prev-next-button.previous');
      prevEl.setAttribute('disabled', 'disabled');
    }

    document.querySelectorAll('.product-main .flickity-prev-next-button').forEach((item) => {
      item.onclick = function() {
        const els =  document.querySelectorAll('.product-main .media__thumb');
        const prevEl = document.querySelector('.product-main .flickity-prev-next-button.previous');
        const nextEl = document.querySelector('.product-main .flickity-prev-next-button.next');
        const len = els.length;
        let cur = 0;
        els.forEach((el, i) => {
          if  (el.classList.contains('is-activated')) {
            cur = i;
          }
        });

        if (item.classList.contains('previous')) {
          if (cur == 0) {
            cur = len - 1;
          } else {
            cur = cur - 1;
          }

          if (cur == len -1) {}

          els.forEach((el, i) => {
            if  (i === cur) {
              el.click();
            }
          });
        } else {
          if (cur == len - 1) {
            cur = 0;
          } else {
            cur = cur + 1;
          }
          
          els.forEach((el, i) => {
            if  (i === cur) {
              el.click();
            }
          });
          
        }
      }
    })
  }

  // window.addEventListener('load', function() {
  //   updateCarouselProduct();
  // })

  function videoList() {
    if (document.querySelectorAll('[data-trigger-play]').length && MicroModal) {
      MicroModal.init({
        onShow: () => {},
        onClose: () => {
          document.querySelectorAll('.rte__video-wrapper1').forEach(function(item) {
            item.innerHTML = '';
          })
        },
        openTrigger: 'data-trigger-play',
      });
    }
  }

  videoList();
  
  
})();
